module.exports = __webpack_public_path__ + "img/8da99bf6cbd643b3c4480f6757293937.svg";